import { create } from 'zustand';
import { IS_DEV_MODE } from '@/shared/const';
import { devtools } from 'zustand/middleware';
import { MOCK_USER, MOCK_USER_DATA } from '../data';
import { User, UserData } from '../types/userTypes';
import { UserStoreSchema } from '../types/userSchema';

const userData = IS_DEV_MODE ? MOCK_USER_DATA : ({} as UserData);
const user = IS_DEV_MODE ? MOCK_USER : ({} as User);
const isAuth = IS_DEV_MODE;

export const useUserStore = create<UserStoreSchema>()(
    devtools((set) => ({
        user,
        setUser: (user) => set({ user }),

        userData,
        setUserData: (userData) => set({ userData }),

        isAuth,
        setIsAuth: (isAuth) => set({ isAuth }),

        isUserLoading: false,
        setIsUserLoading: (isUserLoading) => set({ isUserLoading }),

        isUserDataLoading: false,
        setIsUserDataLoading: (isUserDataLoading) => set({ isUserDataLoading }),

        isNoData: false,
        setIsNoData: (isNoData) => set({ isNoData }),

        isNoAccess: false,
        setIsNoAccess: (isNoData) => set({ isNoData }),

        cleanupUserStore: () =>
            set({
                user: {} as User,
                userData: {} as UserData,
                isAuth: false,
                isUserLoading: false,
                isUserDataLoading: false,
                isNoData: false,
                isNoAccess: false,
            }),
    }))
);
